export function filenameFromDisposition(header, fallback) {
  if (!header) return fallback;
  const star = header.match(/filename\*=UTF-8''([^;]+)/i);
  if (star) {
    try {
      return decodeURIComponent(star[1]);
    } catch {
      return fallback;
    }
  }
  const plain = header.match(/filename="([^"]+)"/i) || header.match(/filename=([^;]+)/i);
  return plain ? plain[1].trim() : fallback;
}

export function formatWon(n) {
  return `${Number(n || 0).toLocaleString("ko-KR")}원`;
}

export function formatSignedWon(n) {
  const v = Number(n || 0);
  const abs = Math.abs(v).toLocaleString("ko-KR");
  if (v > 0) return `+ ${abs}원`;
  if (v < 0) return `- ${abs}원`;
  return `${abs}원`;
}
